(function() {
  // 6. Memory Leak Protection: Ensure fetch is only wrapped once
  if (window.__authCartInterceptorInstalled) return;
  window.__authCartInterceptorInstalled = true;

  const originalFetch = window.fetch.bind(window);
  const SESSION_KEY = 'vds_auth_cart_payload';
  const EXPIRATION_MS = 10 * 60 * 1000; // 10 minutes

  function generateNonce() {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  }

  function checkAndReplayCart() {
    // 3. Clear payload on logout: If customer is not logged in, ensure we don't hold stale payloads
    if (window.Shopify?.customerIsLoggedIn === false) {
      sessionStorage.removeItem(SESSION_KEY);
      return;
    }

    if (window.Shopify?.customerIsLoggedIn) {
      const savedPayloadStr = sessionStorage.getItem(SESSION_KEY);
      if (savedPayloadStr) {
        // Immediately remove to prevent any local double-firing loops
        sessionStorage.removeItem(SESSION_KEY);

        try {
          const payload = JSON.parse(savedPayloadStr);
          
          // 4. Malformed Payload Protection
          if (!payload || !payload.timestamp || !payload.nonce || !payload.data) {
            console.warn('Discarded malformed cart payload');
            return;
          }

          // 8. Expiration Check
          const now = Date.now();
          if (now - payload.timestamp > EXPIRATION_MS) {
            console.log('Cart payload expired');
            return;
          }

          // 2. Cross-Tab Duplicate Protection (Locking via localStorage and Nonce)
          // If a user duplicates a tab mid-redirect, sessionStorage is cloned. 
          // We use localStorage to track the last replayed nonce globally across tabs.
          const lastReplayNonce = localStorage.getItem('vds_last_replay');
          if (lastReplayNonce === payload.nonce) {
            console.log('Cart payload already replayed in another tab');
            return;
          }
          localStorage.setItem('vds_last_replay', payload.nonce);

          let fetchOptions = {
            method: 'POST',
            headers: payload.headers || {}
          };
          
          if (!fetchOptions.headers['X-Requested-With']) {
            fetchOptions.headers['X-Requested-With'] = 'XMLHttpRequest';
          }

          // 5. Restore full payload perfectly
          if (payload.type === 'FormData') {
            const formData = new FormData();
            // This blindly restores ALL keys: variant, quantity, selling_plan, properties, and sections.
            payload.data.forEach(([key, value]) => formData.append(key, value));
            fetchOptions.body = formData;
          } else if (payload.type === 'JSON') {
            fetchOptions.body = JSON.stringify(payload.data);
            if (!fetchOptions.headers['Content-Type']) {
                fetchOptions.headers['Content-Type'] = 'application/json';
            }
          }

          // 6. Replay exact request
          originalFetch('/cart/add.js', fetchOptions)
            .then(res => res.json())
            .then(item => {
              // Preserve Native UX for Custom VDS Sections
              if (typeof window.updateCartCount === 'function') {
                window.updateCartCount();
              }
              document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
              if (typeof window.showVdsToast === 'function') {
                window.showVdsToast('Added to Cart', item.title || 'Product added successfully.', item.image || null);
              }
              
              // Preserve Native UX for Dawn Components
              const detail = {
                resource: item, 
                sourceId: 'auth-cart-replay',
                data: {
                  sections: item.sections, 
                  source: 'auth-cart-replay'
                }
              };
              document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail }));
            })
            .catch(err => console.error('Cart replay failed', err));
        } catch (e) {
          console.error('Error parsing cart payload', e);
        }
      }
    }
  }

  // Intercept fetch
  window.fetch = async function(...args) {
    const [resource, options] = args;
    let url = '';
    
    if (typeof resource === 'string') {
      url = resource;
    } else if (resource instanceof Request) {
      url = resource.url;
    } else if (resource instanceof URL) {
      url = resource.toString();
    }
    
    let parsedUrl;
    try {
      parsedUrl = new URL(url, window.location.origin);
    } catch (e) {
      return originalFetch(...args);
    }

    // Intercept ONLY /cart/add or /cart/add.js
    if (parsedUrl.pathname === '/cart/add' || parsedUrl.pathname === '/cart/add.js') {
      if (window.Shopify?.customerIsLoggedIn === false) {
        
        // 7. Duplicate Protection (2 seconds)
        // Prevents double-clicks from firing multiple redirects or overwriting payload
        const lastIntercept = sessionStorage.getItem(SESSION_KEY + '_time');
        const now = Date.now();
        if (lastIntercept && (now - parseInt(lastIntercept)) < 2000) {
          // 1. Safe Rejection: Reject with AbortError so caller's try/catch can handle it gracefully
          return Promise.reject(new DOMException('Duplicate Add to Cart intercepted', 'AbortError'));
        }
        sessionStorage.setItem(SESSION_KEY + '_time', now.toString());

        let payload = {
          timestamp: now,
          nonce: generateNonce(),
          type: 'JSON',
          data: null,
          headers: options?.headers || {}
        };

        if (options && options.body) {
          if (options.body instanceof FormData) {
            payload.type = 'FormData';
            const formDataEntries = [];
            for (let pair of options.body.entries()) {
              formDataEntries.push([pair[0], pair[1]]);
            }
            payload.data = formDataEntries;
          } else if (typeof options.body === 'string') {
            payload.type = 'JSON';
            try {
              payload.data = JSON.parse(options.body);
            } catch (e) {
              payload.data = options.body;
            }
          } else {
             payload.type = 'JSON';
             payload.data = options.body;
          }
        }

        sessionStorage.setItem(SESSION_KEY, JSON.stringify(payload));

        const loginUrl = new URL(window.Shopify.storefrontLoginUrl, window.location.origin);
        loginUrl.searchParams.set("return_to", window.location.pathname + window.location.search);
        window.location.href = loginUrl.toString();

        // 1. Safe Rejection: Reject with AbortError instead of a hanging Promise.
        // This is standard for aborted fetches and allows caller UI loaders to stop gracefully.
        return Promise.reject(new DOMException('Add to Cart aborted for login redirect', 'AbortError'));
      }
    }

    // Preserve original fetch for all other requests
    return originalFetch(...args);
  };
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAndReplayCart);
  } else {
    checkAndReplayCart();
  }
})();
